import { render } from "./VoiceList.vue?vue&type=template&id=5ee94487&scoped=true"
import script from "./VoiceList.vue?vue&type=script&lang=js"
export * from "./VoiceList.vue?vue&type=script&lang=js"

import "./VoiceList.vue?vue&type=style&index=0&id=5ee94487&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee94487"]])

export default __exports__